var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-carousel-item',[_c('Content',{attrs:{"parcours":_vm.parcours,"forceShowRuleTags":true,"hideRuleTagsBlock":_vm.hideRuleTagsBlock}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }